module.exports = __webpack_public_path__ + "03_medium_grey.ff8e31e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_medium_grey.png
// module id = 8znI
// module chunks = 0